<div class="custom-steppers">
  <via-step
    *ngFor="let step of stepperData; let i = index"
    [stepData]="step"
    [activeIndex]="stepperService.ActiveIndex"
    [maxStepCompleted]="stepperService.MaxStepCompleted"
    [stepIndex]="i"
    (click)="onStepperClick(i)"
  ></via-step>
</div>
